const STATIC_URL = "https://vialantis.fra1.cdn.digitaloceanspaces.com/static/sound";

const Sounds = {
  alarm: `${STATIC_URL}/notification/alarm.mp3`,
  push: `${STATIC_URL}/notification/push.mp3`,
};

export default Sounds;
